import * as React from "react";
import { RouteComponentProps } from "react-router";
import { Container, Row, Button, Col } from "react-bootstrap";
import { Result } from '../../models/Result'
import { LinkContainer } from "react-router-bootstrap";
import { useState } from "react";
import ResultService from "services/ResultService";
import { Resultview } from "components/views/ResultView";
import { MainLayout } from "components/layouts/MainLayout";
import LoadingView from "components/views/LoadingView";
import HttpStatusCode from "helpers/HttpStatusCode";
import l10n from "localization/LocalizationData";
import { ResultPrintView } from "components/views/ResultPrintView";


export interface ResultPageProps {
	code?: string;
}

export interface ResultPageState {
	code: string;
	busy: boolean;
	result: Result | null;
}

export const ResultPage = (props: RouteComponentProps<ResultPageProps>) => {
	const [loading, setLoading] = useState(true);
	const [results, setResults] = useState<Result>();
	const [lastCode, setLastCode] = useState<HttpStatusCode | null>(null);
	const [retry, setRetry] = useState(false);
	const code = props.match.params.code as string;
	React.useEffect(() => {
		if (code !== '') {
			ResultService.get(code as string)
				.then((result: Result) => {
					setResults(result);
					setLastCode(HttpStatusCode.OK);
				}).catch((statusCode: HttpStatusCode) => {
					setLastCode(statusCode);
				}).finally(() => {
					setLoading(false);
				});
		}
	}, [code])

	React.useEffect(() => {
		if (retry && code) {
			setLoading(true);
			ResultService.get(code as string)
				.then((result: Result) => {
					setResults(result);
					setLastCode(HttpStatusCode.OK);
				}).catch((statusCode: HttpStatusCode) => {
					setLastCode(statusCode);
				}).finally(() => {
					setLoading(false);
					setRetry(false);
				});
		}
	}, [retry, code])

	function onRetry() {
		setRetry(true);
	}

	if (loading === true) {
		return (
			<MainLayout>
				<LoadingView title={l10n.loading} />
			</MainLayout>
		)
	}

	if (results !== undefined) {
		return (
			<MainLayout header={
				<div className='share-header'>
					<a className='survey-btn' href='https://link.webropolsurveys.com/S/7880410DFA22C2D8' target='_blank' rel='noopener noreferrer'>
						<Button className='no-print'>{l10n.resultSharing_survey}</Button>
					</a>
					<LinkContainer to='/'>
						<Button className='no-print'>{l10n.button_toHome}</Button>
					</LinkContainer>
				</div>
			}>
				<Container>
					<h1 className='my-4 mb-0'>{results.questionnaire.resultName !== undefined ? results.questionnaire.resultName : results.questionnaire.name}</h1>
					<ResultPrintView result={results} />
					<Resultview result={results} />
					<Row className='justify-content-center my-3'>
						<Col xs='auto' className='offset-1'>
							<Button variant='primary' className='no-print' onClick={() => { window.print() }}>{l10n.button_printPdf}</Button>
						</Col>
					</Row>
				</Container >
			</MainLayout>
		);
	}

	let errorText = l10n.error_result;
	if (lastCode === HttpStatusCode.NotFound) {
		errorText = l10n.error_result_notFound;
	}

	return (
		<MainLayout header={<LinkContainer to='/'>
			<Button>{l10n.button_toHome}</Button>
		</LinkContainer>}>
			<Container>
				<Row className='justify-content-center mb-4 mt-4'><h2>{errorText}</h2></Row>
				<Row className='justify-content-center'><Col xs='auto'><Button onClick={() => onRetry()}>{l10n.button_tryAgain}</Button></Col></Row>
			</Container>
		</MainLayout>
	);
}